import React from "react";
import { Field } from "redux-form";

import { CustomInput } from "components";
import { FormColumn, FormRow } from "components/layout";
import { trimNormalizer } from "validators";
import {
	maxLength20,
	maxLength30,
	onlyAlphanumericAndSpecialCharacters,
} from "validators/validation";

type OtherFieldsProps = {
	loading: boolean;
	name: string;
};

export const OtherFields = ({ loading, name }: OtherFieldsProps) => {
	return (
		<FormRow>
			<FormColumn>
				<Field
					label="Processor Description"
					component={CustomInput}
					smLabel={5}
					smSelect={7}
					type="text"
					name={`${name}.description`}
					validate={maxLength30}
					blurLoading={loading}
					normalizeOnBlur={trimNormalizer}
					normalize={onlyAlphanumericAndSpecialCharacters}
					hideRequiredMark
				/>
			</FormColumn>
			<FormColumn>
				<Field
					label="Rep Code"
					component={CustomInput}
					smLabel={5}
					smSelect={7}
					type="text"
					name={`${name}.rep_code_one`}
					validate={maxLength20}
					blurLoading={loading}
					normalizeOnBlur={trimNormalizer}
					normalize={onlyAlphanumericAndSpecialCharacters}
					hideRequiredMark
				/>
			</FormColumn>
			<Field
				component={CustomInput}
				type="hidden"
				name={`${name}.id`}
				disabled
				wrapperClassName="d-none"
			/>
		</FormRow>
	);
};
